import { NextSeo } from 'next-seo';

import classNames from 'classnames';

import { policyWrapper } from '@styles/PolicyStyles';
import { HeaderV2Options } from '@type/web/header';

import AppLayout from '@components/web/Layout/AppLayout';

const Youthpolicy = (): JSX.Element => {
  const headerOptions: HeaderV2Options = {
    isFixed: {
      pc: false,
      tablet: true,
    },
    isTopPosition: false,
    isShowBackground: true,
    showAppDownloadBtn: false,
    showNavigationBar: [],
    title: {
      text: '청소년보호정책',
      showTitle: ['mobile', 'tablet', 'desktop'],
    },
  };
  return (
    <AppLayout headerOptions={headerOptions}>
      <NextSeo
        title="청소년보호정책"
        description="중고나라 청소년보호정책입니다."
      />
      <main css={{ backgroundColor: '#e1e1e1' }}>
        <div css={policyWrapper}>
          <p className="f13 c_gray">
            (주)중고나라(이하 &quot;회사&quot;라 함)는 청소년 유해환경으로부터
            청소년을 보호하고 청소년이 건전한 인격체로 성장할 수 있도록 돕기
            위해 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 청소년보호법에
            근거하여 청소년보호정책을 수립, 시행하고 있습니다.
          </p>
          <dl
            className={classNames(
              'f13',
              'c_gray',
              'mt20',
              'list_desc',
              'termsCont',
            )}
          >
            <dt className="relative pd_l20">
              <span className="desc">
                <strong>1.</strong>
              </span>
              <p>
                <strong>개인정보 수집 및 이용 목적</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    19세 미만의 청소년들이 유해정보에 접근할 수 없도록 별도의
                    인증장치를 마련하고 있으며, 모니터링 등 청소년유해정보가
                    노출되지 않도록 사전예방조치를 강구하고 있습니다.
                  </p>
                </li>
              </ul>
            </dd>
            <dt className="relative pd_l20 mt10">
              <span className="desc">
                <strong>2.</strong>
              </span>
              <p>
                <strong>청소년보호를 위한 교육</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    회사는 청소년보호책임자와 담당부서를 대상으로 청소년보호
                    관련 법령 및 제재 기준, 유해정보 발견시 대처방법 등을
                    교육하고 있습니다.
                  </p>
                </li>
              </ul>
            </dd>
            <dt className="relative pd_l20 mt10">
              <span className="desc">
                <strong>3.</strong>
              </span>
              <p>
                <strong>청소년보호를 위한 피해상담 및 고충처리</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    회사는 유해정보로 인한 피해 상담 및 고충처리를 위하여
                    청소년보호책임자 지정과 담당부서를 운영하여 피해가 확산되지
                    않도록 하고 있습니다
                  </p>
                </li>
              </ul>
            </dd>
            <dt className="relative pd_l20 mt10">
              <span className="desc">
                <strong>4.</strong>
              </span>
              <p>
                <strong>청소년보호책임자 및 담당부서</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li className="pd_l20">
                  <strong>[청소년보호책임자]</strong>
                </li>
                <li className="mt10 pd_l20">
                  <p>성명 : 이혜련</p>
                </li>
                <li className="pd_l20">
                  <p>전화번호 : 1533-7861</p>
                </li>
                <li className="pd_l20">
                  <p>팩스 : 070-8220-5331</p>
                </li>
                <li className="pd_l20">
                  <p>
                    전자우편 :{' '}
                    <a href="mailto: joongna@joonggonara.co.kr">
                      joongna@joonggonara.co.kr
                    </a>
                  </p>
                </li>
                <li className="mt10 pd_l20">
                  <strong>[청소년보호책임 담당부서]</strong>
                </li>
                <li className="mt10 pd_l20">
                  <p>부서명 : 서비스운영팀</p>
                </li>
                <li className="pd_l20">
                  <p>전화번호 : 1533-7861</p>
                </li>
                <li className="pd_l20">
                  <p>
                    전자우편 :{' '}
                    <a href="mailto: joongna@joonggonara.co.kr">
                      joongna@joonggonara.co.kr
                    </a>
                  </p>
                </li>
              </ul>
            </dd>
          </dl>
          <p className="f13 c_gray mt20">공고일자 : 2022년 11월 08일</p>
          <p className="f13 c_gray">시행일자 : 2022년 11월 08일</p>
        </div>
      </main>
    </AppLayout>
  );
};

export default Youthpolicy;
